import { CmsObjectWithDefault } from '@components/Cms/types';

export type WalletAuthCmsKey =
    | 'SuccessTitle'
    | 'SuccessCaption'
    | 'InvalidDob'
    | 'SessionExpired'
    | 'InvalidOtp'
    | 'TechnicalDifficulty'
    | 'CreatePinTitle'
    | 'CreatePinDisclaimer'
    | 'VerifyPinTitle'
    | 'VerifyPinCaption'
    | 'ConfirmPinTitle'
    | 'ConfirmPinCaption'
    | 'IncorrectPin'
    | 'TechnicalDifficulty'
    | 'RequestBlockedReason'
    | 'RequestBlockedDetail';

export const WalletAuthCmsWithDefault: CmsObjectWithDefault<WalletAuthCmsKey> = {
    ConfirmPinTitle: {
        cmsId: 368050,
        defaultTranslation: 'Confirm PIN',
    },
    ConfirmPinCaption: {
        cmsId: 368051,
        defaultTranslation: 'Enter your 6-digit PIN to continue.',
    },
    TechnicalDifficulty: {
        cmsId: 101793,
        defaultTranslation: 'We are currently experiencing technical difficulties.',
    },
    SuccessTitle: {
        cmsId: 368055,
        defaultTranslation: 'New PIN code has been set',
    },
    SuccessCaption: {
        cmsId: 368056,
        defaultTranslation: 'You can use it to access the wallet and authorise any future transactions',
    },
    InvalidDob: {
        cmsId: 368058,
        defaultTranslation: 'Error, authentication failed. Please wait a while and try again.',
    },
    SessionExpired: {
        cmsId: 368059,
        defaultTranslation: 'The Session has expired. Please try again.',
    },
    InvalidOtp: {
        cmsId: 398433,
        defaultTranslation: 'Invalid OTP input. Please try again',
    },
    CreatePinTitle: {
        cmsId: 358282,
        defaultTranslation: 'Create your 6-digit PIN',
    },
    CreatePinDisclaimer: {
        cmsId: 358284,
        defaultTranslation: 'Do not share this code with anyone.',
    },
    VerifyPinCaption: {
        cmsId: 358287,
        defaultTranslation: 'Enter the same 6-digit PIN again to confirm',
    },
    VerifyPinTitle: {
        cmsId: 358286,
        defaultTranslation: 'Verify PIN code',
    },
    IncorrectPin: {
        cmsId: 398436,
        defaultTranslation: 'Incorrect PIN. Please try again.',
    },
    RequestBlockedReason: {
        cmsId: 416774,
        defaultTranslation: 'This account has been temporarily locked for security reasons.',
    },
    RequestBlockedDetail: {
        cmsId: 416775,
        defaultTranslation: 'Please reset your PIN or wait until {0} to try again.',
    },
};
